import React, { useEffect, useState } from 'react';
import Filter from './filter';
import './timeline.css';
import { Card } from 'primereact/card';
import 'primeicons/primeicons.css';
import { Timeline } from 'primereact/timeline';
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import './filter.css';
import './filterBy.css';
import properties from '../../config/environmentProperties';
import { timesheetApi } from '../../services';

function ProjectsTimeline() {
    const [timeLineData, setTimeLineData] = useState({});
    const [userName, setUserName] = useState('My Timeline');
    const user = useSelector(selectUser);
    const imgPath = properties.currentEnvironment.docPath + 'images/';
    const fullURL = window.location.href;
    const url = new URL(fullURL);
    const empTimelineId = url.searchParams.get('id') || user.id;
    const capitalizeFirstLetter = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());

    useEffect(() => {
        getTimeline();
    }, []);

    const getTimeline = async (filter = {}) => {
        try {
            const obj = { userId: empTimelineId, ...filter };
            const resp = await timesheetApi.getProjectByUserId(obj);
            const data = resp.data.data;
            if (empTimelineId !== user.id) {
                const { firstName, lastName } = data[Object.keys(data)[0]][0];
                const userNameFormatted = capitalizeFirstLetter(`${firstName} ${lastName}`);
                setUserName(`${userNameFormatted}'s TimeLine`);
            }
            setTimeLineData(data);
        } catch (err) {
            console.error(err);
        }
    };

    const filterSelected = (obj) => {
        getTimeline(obj);
    };

    const updateTimeLine = (data) => {
        setTimeLineData(data);
    };

    const customizedContent = (items) => {
        return (
            <div className="cards-container">
                {items.map((item, index) => (
                    <Card className="project_card" key={index}>
                        <div style={{ display: "flex" }}>
                            <span className='project_icon'>
                                {item?.logo == null ?
                                    <span className='timeline-span'>{item?.projectTitle.substr(0, 1)}</span> :
                                    <img src={item?.logo || ''} alt='NoImg' />}
                            </span>

                            <span className='ml-4'>
                                <div className='project_name'>{item?.projectTitle}</div>
                                <div>{item.startDate} - {item.endDate}</div>
                                <div className='project_status'>
                                    {item.isBillable === true ? (
                                        <small style={{ color: "green" }}>Billable</small>
                                    ) : (
                                        <small style={{ color: "red" }}>Non-Billable</small>
                                    )}
                                    <div style={{ paddingLeft: 30 }}>{item?.percentage}%</div>
                                </div>
                            </span>
                        </div>
                    </Card>
                ))}
            </div>
        );
    };

    const timelinePhoto = localStorage.getItem('userPhoto')
    const customizedMarker = (date) => {
        return (
            <div className="date-profile-wrapper">
                <div className='profile-image-timeline'>
                    {((userName === "My Timeline" && user.photo) || timelinePhoto) ? (
                        <img className='profile-photo' src={imgPath + (userName === "My Timeline" ? user.photo : timelinePhoto)} alt='' />
                    ) : (
                        <span className='timeline-span'>
                            {user.firstName.charAt(0).toUpperCase()}
                            {user.lastName.charAt(0).toUpperCase()}
                        </span>
                    )}
                </div>
                <div>{date}</div>
            </div >
        );
    };

    const sortedDates = Object.keys(timeLineData).sort((a, b) => new Date(b) - new Date(a));
    return (
        <div>
            <h1>{userName}</h1>
            <Filter onSelection={filterSelected} user updateTimeLine={updateTimeLine} />
            <Timeline value={sortedDates} align="opposite" className="customized-timeline"
                marker={customizedMarker}
                content={(date) => customizedContent(timeLineData[date] || [])}
            />
        </div>
    );
}

export default ProjectsTimeline;